import {useUpmPlantsContext} from '@hconnect/upm'
import {useSuiteHierarchyId} from '@hproduce/suite-core'
import {useParams} from 'react-router'

export const usePlantUpmIdFromUrl = () => {
  const params = useParams<{plantId?: string}>()
  const upmPlants = useUpmPlantsContext()

  const plantCode = params['plantId']
  const hierarchyId = useSuiteHierarchyId()

  if (hierarchyId) return hierarchyId
  if (!plantCode) {
    throw new Error('Plant code is required to get Plant UPM ID')
  }

  return upmPlants?.[plantCode]?.upmId
}
